<template><div class="cabins-guests cabins-guests--preview" id="guests">
    <div class="cabins-guests__header">Проверьте правильность заполненной информации</div>

    <div class="cabins-guests__content">

        <div class="cabins-guests__section">

        <div class="cabin" v-for="({id, Cabin, CabinSet, places, ages}) in cstore.getCabins" :key="id">
          <div class="cabin__wrapper">
            <div class="cabin__header cabin-header">
              <div class="cabin-header__content">
                <div class="cabin-header__title">{{ /^\d+$/.test(Cabin.name) ? `Каюта ${Cabin.name}` : Cabin.name }}</div>
                <div class="cabin-header__deck">{{ /палуба/i.test(Cabin.deck.name) ? Cabin.deck.name : `${Cabin.deck.name} палуба` }}</div>
              </div>
            </div>
            <div class="cabin__content cabin-content">
              <template v-for="place in places">
                <FillPlacePreview
                  class="cabin-content__place"
                  :place="place"
                  :cabinId="id"
                  :Cabin="Cabin"
                  :ages="ages"
                  :key="place.pnum"
                  viewMode="full"
                  validationMode="strict"
                />
              </template>
            </div>
            <CabinPrice :precalc="bookPrecalc" :cabinId="id" childClass="cabin-footer" class="cabin__footer cabin-footer" />
          </div>

          <CabinErrors :errors="cabinErrors[id]" :double="true" />

        </div>

      </div>

      <div class="cabins-guests__section">

        <div class="cabin">
            <div class="cabin__wrapper">
                <div class="cabin__header cabin-header">
                    <div class="cabin-header__content">
                        <div class="cabin-header__title">Заказчик</div>
                    </div>
                </div>
                <div class="cabin__content cabin-content">
                    <FillPlacePreview
                      class="cabin__persons__place"
                      :place="bookCabins.customerCabinPlace"
                      :cabinId="bookCabins.customerCabinId"
                      viewMode="full"
                      validationMode="strict"
                    />
                </div>
                <CabinPrice v-if="cstore.getCabins.length>1" :precalc="bookPrecalc" :sum="true" childClass="cabin-footer" class="cabin__footer cabin-footer" />
            </div>

            <CabinErrors :errors="cabinErrors[cuCabin]" :double="true" />
            
        </div>

        <div class="cabin" style="grid-column: span 2;">
          <div class="cabin__wrapper">
            <div class="cabin__header cabin-header">
              <div class="cabin-header__content">
                <div class="cabin-header__title">Комментарии и скидки</div>
              </div>
            </div>
            <div class="cabin__content cabin-content">
              <div class="cabin-content__comment">
                <textarea v-model="bookCabins.notes_note" placeholder="Ваш комментарий к заказу"></textarea>
              </div>
              <div class="cabin-content__checkbox-options">
                <MyCheckbox :choosed="bookCabins.notes_attachDoc" @input="bookCabins.notes_attachDoc = $event">
                  <span>Пенсионная скидка</span>
                </MyCheckbox>
                <div v-if="bookCabins.notes_attachDoc">Для подтверждения скидки прикрепите пенсионное удостоверение после сохранения заявки</div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>


<script setup>
import '@/comp/FaseBook/CabinsGuests.scss'
  
import { computed, onMounted, unref } from 'vue'
import useCruiseStore from '@/cstore.js'
import useCabinsStore from '@/bookCabins.js'
import useTouristStore from '@/tourist/tourist-store.js'
import FillPlacePreview from '@/comp/FaseBook/FillPlacePreview.vue'
import PriceCurrencyV from '@/comp/CruiseHead/PriceCurrencyV.vue'
import MyCheckbox from '@/comp/MyCheckbox/MyCheckbox.vue'
import {beforeBookCheck} from '@/comp/useOrder.js'

import CabinPrice from '@/comp/FaseBook/CabinPrice.vue'

import CabinErrors from '@/comp/FaseBook/CabinErrors.vue'


const cstore = useCruiseStore()
const bookCabins = useCabinsStore()
const tstore = useTouristStore()

onMounted(() => {
  bookCabins.initBookPrecalc({ cstore, tstore, bookCabins })
})

const bookPrecalc = bookCabins.getBookPrecalc()
const cuCabin = bookCabins.customerCabinId

const cabinErrors = computed(() => {
    const {errsByCabin} = beforeBookCheck( cstore, tstore, bookCabins  )
    return errsByCabin
})


</script>
